import React from 'react';
import Button from '@hig/button';
import './WizardNavigation.css';

const WizardNavigation = ({ currentStep, canGoNext, canGoBack, onNext, onBack, isLastStep }) => {
    return (
        <div className="wizard-navigation">
            <div className="wizard-nav-left">
                {canGoBack && (
                    <Button
                        size="standard"
                        title="Back"
                        type="secondary"
                        onClick={onBack}
                    />
                )}
            </div>
            <div className="wizard-nav-right">
                {!isLastStep && (
                    <Button
                        size="standard"
                        title="Next"
                        type="primary"
                        onClick={onNext}
                        disabled={!canGoNext}
                    />
                )}
            </div>
        </div>
    );
};

export default WizardNavigation;
